var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card__title" }, [
      _c("h6", [_c("b", [_vm._v(_vm._s(_vm.title))])]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.imagenes.length > 0,
              expression: "imagenes.length > 0"
            }
          ],
          staticClass: "card__controls"
        },
        [
          _c(
            "button",
            {
              staticClass: "btn-light btn--text",
              attrs: { type: "button" },
              on: { click: _vm.copiarLinks }
            },
            [
              _c("i", { staticClass: "fa fa-link" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.copiarLinks")))])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.descargarGrupo }
            },
            [
              _c("i", { staticClass: "fa fa-download" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.descargarTodo")))])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.imagenes.length > 0,
            expression: "imagenes.length > 0"
          }
        ],
        staticClass: "card__content"
      },
      [
        _c("div", { staticClass: "card__content px-0" }, [
          _c(
            "div",
            { staticClass: "carrousel" },
            _vm._l(_vm.imagenes, function(imagen, index) {
              return _c("div", { key: index }, [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("message.usuario")) +
                      ": " +
                      _vm._s(
                        imagen.usuario !== undefined && imagen.usuario !== null
                          ? imagen.usuario.nombre_usuario
                          : "-"
                      )
                  )
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-container",
                  attrs: { src: imagen.url, alt: imagen.url },
                  on: {
                    click: function($event) {
                      return _vm.verImagen(imagen)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    { attrs: { tooltip: imagen.url_publica } },
                    [
                      _c("input-field", {
                        attrs: { id: "link" + _vm.title + index, readonly: "" },
                        model: {
                          value: imagen.url_publica,
                          callback: function($$v) {
                            _vm.$set(imagen, "url_publica", $$v)
                          },
                          expression: "imagen.url_publica"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn-success btn--text",
                      attrs: { href: imagen.url_publica, download: "" }
                    },
                    [_c("i", { staticClass: "fa fa-download" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-secondary btn--text",
                      on: {
                        click: function($event) {
                          return _vm.copiarLink(imagen.url_publica)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-clone" })]
                  )
                ])
              ])
            }),
            0
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7000e6d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7000e6d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/clientes/ItemGrupoContenedor.vue
// module id = 313
// module chunks = 0